import { Button, Col, Row, Space, Typography } from "antd";
import MyCalendarView from "../components/MyCalendarView";
import { useState } from "react";

function MyCalendarPage() {
  const [openEvent, setOpenEvent] = useState<
    "add" | "update" | "delete" | "preview" | null
  >(null);

  // Events

  function onAddEvent(): void {
    setOpenEvent("add");
  }

  function onEventClose(): void {
    setOpenEvent(null);
  }

  return (
    <Col className="flex flex-1 flex-col overflow-hidden p-4">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4 pl-0 pr-0">
        <Typography.Title className="m-0 flex-auto" level={4}>
          My Calendar
        </Typography.Title>
        <Space className="flex flex-row">
          <Button type="primary" onClick={onAddEvent}>
            Add Event
          </Button>
        </Space>
      </Row>
      <MyCalendarView openEvent={openEvent} onEventClose={onEventClose} />
    </Col>
  );
}

export default MyCalendarPage;
